import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { KDResponse } from 'src/app/models/KDResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KDService {

  apiLink = environment.apiLink;
  httpOption = httpOptions

  constructor(private http: HttpClient) { }

  getKDDocksData(): Observable<KDResponse> {
    return this.http.get<KDResponse>(`${this.apiLink}/KD/Docks`, httpOptions)
  }

  getKDDocksDataView(): Observable<KDResponse> {
    return this.http.get<KDResponse>(`${this.apiLink}/View/KD/Docks`, httpOptions)
  }
}
